module.exports = __webpack_public_path__ + "assets/img/kv-740b6783.jpg";